const user = (state = false, action: any) => {
	switch(action.type) {
		case 'SET_LIMITED':
			return action.payload;
		default: 
			return state;
	}
}

export default user;